/* global customElements, DOMParser, subscribe, PUB_SUB_EVENTS */
/* Shopify rend les suggestions avec les prix et disponibilités du panier courant. */
if (!customElements.get('slich-cart-complements')) {
  customElements.define('slich-cart-complements', class extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        clearTimeout(this.timer);
        this.controller?.abort();
        // Dès une modification, ne plus proposer un produit potentiellement ajouté.
        this.querySelector('[data-complements-content]').hidden = true;
        this.timer = setTimeout(() => this.load(), 250);
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      }
      document.addEventListener('cart:updated', this.refresh);
      this.onPageShow = event => { if (event.persisted) this.refresh(); };
      window.addEventListener('pageshow', this.onPageShow);
    }
    async load() {
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(this.dataset.cartUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: controller.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Suggestions indisponibles');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-complements-content]');
        if (!content || this.controller !== controller || !this.isConnected) return;
        this.querySelector('[data-complements-content]').replaceWith(content);
      } catch {
        // Les suggestions sont facultatives ; le paiement reste utilisable.
      } finally { clearTimeout(timeout); }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.unsubscribe?.();
      document.removeEventListener('cart:updated', this.refresh);
      window.removeEventListener('pageshow', this.onPageShow);
    }
  });
}
